export default "__VITE_ASSET__3f60db1a__"